import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-unprocess-claims-prov',
  templateUrl: './unprocess-claims-prov.component.html',
  styleUrls: ['./unprocess-claims-prov.component.scss']
})
export class UnprocessClaimsProvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/unprocess-claims-prov/unprocess-claims-prov.component.ts